/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc, doT, SCS */
	/*jshint smarttabs:true */
	/**
	 * JS Logic for PDF Downdload Component
	 *
	 * @author Matthias Inauen
	 * @namespace Tc.Module
	 * @class DownloadPDF
	 * @extends Tc.Module
	 */
	Tc.Module.DownloadPDF = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.downloadLink = $('a.download', mod.$ctx );
			mod.actionURL = mod.downloadLink.attr('data-url');
			mod.parentForm = mod.downloadLink.parents('form');

			$("input[name=':formid'],[name=':formstart'],[name=':formtype']", mod.parentForm ).remove();

			mod.parentFormContents = mod.parentForm.contents();
			mod.submitForm = $('<form />', { method: 'post', action: this.actionURL, target: '_blank' });

			mod.downloadLink.click( function( event ){
				event.preventDefault();

				mod.submitForm.append( mod.parentFormContents.detach() ).appendTo( 'body').submit().detach();
				mod.parentForm.append( mod.parentFormContents.detach() );
			});

			callback();
		}
	});
})(Tc.$);
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.DownloadPDF.js
// module id = 198
// module chunks = 0